import React, { ReactNode, useState } from 'react';

import ArrowCollapse from '../styles/images/arrow-collapse.svg';
import ArrowExpand from '../styles/images/arrow-expand.svg';

import '../styles/collapsible-box.scss';

interface CollapsibleBoxProps {
  title: string;
  initialOpen?: boolean;
  children: ReactNode;
}

const CollapsibleBox: React.FC<CollapsibleBoxProps> = ({
  title,
  initialOpen = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen);

  const handleToggle = (e: React.SyntheticEvent<HTMLDetailsElement>) => {
    setIsOpen(e.currentTarget.open);
  };

  return (
    <details
      className="collapsible-box"
      open={initialOpen}
      onToggle={handleToggle}>
      <summary className="collapsible-box__trigger">
        <img
          src={isOpen ? ArrowExpand : ArrowCollapse}
          alt={isOpen ? 'ArrowExpand' : 'ArrowCollapse'}
        />
        <h5>{title}</h5>
      </summary>
      <div className="collapsible-box__content">{children}</div>
    </details>
  );
};

export default CollapsibleBox;
